export default __webpack_public_path__ + "static/media/choice_couch.82fb9521.png";